"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    anchor: function() {
        return _colors.anchor;
    },
    beige: function() {
        return _colors.beige;
    },
    berry: function() {
        return _colors.berry;
    },
    black: function() {
        return _colors.black;
    },
    blackAlpha: function() {
        return _colors.blackAlpha;
    },
    blue: function() {
        return _colors.blue;
    },
    borderRadius: function() {
        return _borderRadius.borderRadius;
    },
    brass: function() {
        return _colors.brass;
    },
    bronze: function() {
        return _colors.bronze;
    },
    brown: function() {
        return _colors.brown;
    },
    burgundy: function() {
        return _colors.burgundy;
    },
    charcoal: function() {
        return _colors.charcoal;
    },
    cornflower: function() {
        return _colors.cornflower;
    },
    cranberry: function() {
        return _colors.cranberry;
    },
    curves: function() {
        return _curves.curves;
    },
    cyan: function() {
        return _colors.cyan;
    },
    darkBlue: function() {
        return _colors.darkBlue;
    },
    darkBrown: function() {
        return _colors.darkBrown;
    },
    darkGreen: function() {
        return _colors.darkGreen;
    },
    darkOrange: function() {
        return _colors.darkOrange;
    },
    darkPurple: function() {
        return _colors.darkPurple;
    },
    darkRed: function() {
        return _colors.darkRed;
    },
    darkTeal: function() {
        return _colors.darkTeal;
    },
    durations: function() {
        return _durations.durations;
    },
    fontFamilies: function() {
        return _fonts.fontFamilies;
    },
    fontSizes: function() {
        return _fonts.fontSizes;
    },
    fontWeights: function() {
        return _fonts.fontWeights;
    },
    forest: function() {
        return _colors.forest;
    },
    gold: function() {
        return _colors.gold;
    },
    grape: function() {
        return _colors.grape;
    },
    green: function() {
        return _colors.green;
    },
    grey: function() {
        return _colors.grey;
    },
    grey10Alpha: function() {
        return _colors.grey10Alpha;
    },
    grey12Alpha: function() {
        return _colors.grey12Alpha;
    },
    grey14Alpha: function() {
        return _colors.grey14Alpha;
    },
    hcButtonFace: function() {
        return _colors.hcButtonFace;
    },
    hcButtonText: function() {
        return _colors.hcButtonText;
    },
    hcCanvas: function() {
        return _colors.hcCanvas;
    },
    hcCanvasText: function() {
        return _colors.hcCanvasText;
    },
    hcDisabled: function() {
        return _colors.hcDisabled;
    },
    hcHighlight: function() {
        return _colors.hcHighlight;
    },
    hcHighlightText: function() {
        return _colors.hcHighlightText;
    },
    hcHyperlink: function() {
        return _colors.hcHyperlink;
    },
    horizontalSpacings: function() {
        return _spacings.horizontalSpacings;
    },
    hotPink: function() {
        return _colors.hotPink;
    },
    lavender: function() {
        return _colors.lavender;
    },
    lightBlue: function() {
        return _colors.lightBlue;
    },
    lightGreen: function() {
        return _colors.lightGreen;
    },
    lightTeal: function() {
        return _colors.lightTeal;
    },
    lilac: function() {
        return _colors.lilac;
    },
    lime: function() {
        return _colors.lime;
    },
    lineHeights: function() {
        return _fonts.lineHeights;
    },
    magenta: function() {
        return _colors.magenta;
    },
    marigold: function() {
        return _colors.marigold;
    },
    mink: function() {
        return _colors.mink;
    },
    navy: function() {
        return _colors.navy;
    },
    orange: function() {
        return _colors.orange;
    },
    orchid: function() {
        return _colors.orchid;
    },
    peach: function() {
        return _colors.peach;
    },
    pink: function() {
        return _colors.pink;
    },
    platinum: function() {
        return _colors.platinum;
    },
    plum: function() {
        return _colors.plum;
    },
    pumpkin: function() {
        return _colors.pumpkin;
    },
    purple: function() {
        return _colors.purple;
    },
    red: function() {
        return _colors.red;
    },
    royalBlue: function() {
        return _colors.royalBlue;
    },
    seafoam: function() {
        return _colors.seafoam;
    },
    silver: function() {
        return _colors.silver;
    },
    steel: function() {
        return _colors.steel;
    },
    strokeWidths: function() {
        return _strokeWidths.strokeWidths;
    },
    teal: function() {
        return _colors.teal;
    },
    typographyStyles: function() {
        return _typographyStyles.typographyStyles;
    },
    verticalSpacings: function() {
        return _spacings.verticalSpacings;
    },
    white: function() {
        return _colors.white;
    },
    whiteAlpha: function() {
        return _colors.whiteAlpha;
    },
    yellow: function() {
        return _colors.yellow;
    }
});
const _borderRadius = require("./borderRadius.js");
const _colors = require("./colors.js");
const _curves = require("./curves.js");
const _durations = require("./durations.js");
const _fonts = require("./fonts.js");
const _spacings = require("./spacings.js");
const _strokeWidths = require("./strokeWidths.js");
const _typographyStyles = require("./typographyStyles.js");
